module.exports = __webpack_public_path__ + "static/media/cloze-rabbit-shadow.d47f8498.svg";